import styled from '@emotion/styled';
import { theme } from '../../2022-component-library';

export const StyledTable = styled.table`
  border-collapse: collapse;
  position: absolute;

  .snellen {
    display: none;
  }

  .characters {
    display: ${({ displayCharacters }) => (displayCharacters ? 'table-cell' : 'none')};
  }

  .logmar-selection {
    width: 30%;
    max-width: 150px;
  }

  tr {
    cursor: ${({ testInProgress }) => (testInProgress ? 'auto' : 'pointer')};
  }

  th,
  td {
    padding: 8px;
    text-align: left;
    border: 1px solid #ddd;
  }

  input {
    margin-right: 1rem;
  }
  tbody tr:hover {
    background-color: #f5f5f5;
  }
  th {
    background-color: ${theme.colors.primary};
    color: #fff;
    font-weight: bold;
    text-align: center;
  }

  .char-container {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }

  span {
    transition: all 0.2s ease;
    border: 1px solid transparent;
    width: 15px;
    text-align: center;
    padding: 0 0.25rem;
  }

  #${({ highlightedCharacter }) => highlightedCharacter} {
    border: 1px solid black;
    background-color: #ddffdd;
  }
  .active-logmar-char {
    ${({ testInProgress }) =>
      testInProgress &&
      `cursor: pointer;
  &:hover {
  border: 1px solid black;
}`};
  }

  @media (min-width: 915px) {
    .snellen {
      display: table-cell;
      width: 20%;
      text-align: center;
      font-weight: bold;
    }
  }
`;
